module.exports = __webpack_public_path__ + "img/v-icon.d7ffc09b.svg";